/* Copyright 2013 VMware, Inc. All rights reserved. -- VMware Confidential */
/**
 * Reverse an array
 */
angular.module('com.vmware.platform.ui').filter('reverse', [
function() {
   return function(items) {
      return items.slice().reverse();
    };
}]);